import React, { Fragment } from 'react';
import { db } from '../../utils/firebase';
import firebase from 'firebase/app'
import TableComponent from '../../components/TableComponent';
import { filterQuestions } from '../../utils/miscFunctions';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import CreateQuestion from '../../components/Surveys/CreateQuestion';
import AnalysisFields from '../../components/Questions/AnalysisFields';
import AlertDialog from '../../components/AlertDialog';
import SearchDialog from '../../components/SearchDialog';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import _ from 'lodash';
import QuestionContext from '../../QuestionContext';

const languages = [
    { value: 'en', label: 'English' },
    { value: 'es', label: 'Spanish' },
    { value: 'ch', label: 'Chinese' },
    { value: 'ru', label: 'Russian' },
    { value: 'fr', label: 'French' },
    { value: 'tl', label: 'Tagalog' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'ar', label: 'Arabic' },
    { value: 'so', label: 'Somali' },
    { value: 'ko', label: 'Korean' }
]

const types = [
    { value: 'opinion_scale', label: 'Opinion scale' },
    { value: 'multiple_choice', label: 'Multiple choice' },
    { value: 'group', label: 'Group' },
    { value: 'statement', label: 'statement' },
    { value: 'long_text', label: 'Long text' },
    { value: 'short_text', label: 'Short text' },
    { value: 'yes_no', label: 'Yes/No' }
]

const styles = {
    'search': {
        width: '50%',
        margin: 10
    },
    'select': {
        width: '22%',
        margin: 5,
        height: 60,
        fontSize: 16,
    },
    'button': {
        backgroundColor: '#0256c5',
        color: 'white',
        cursor: 'pointer',
        borderRadius: 8,
        fontSize: 16,
        padding: 10,
        margin: 10,
    }
}

class AllQuestions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            typeFilter: '',
            languageFilter: '',
            searchTerm: '',
            page: 0,
            rowsPerPage: 10,
            questionModal: false,
            questionData: null,
            openAlert: false,
            openNewQuestion: false,
            alertTitle: '',
            alertText: '',
            alertType: '',
            openSnackbar: false,
            snackbarMessage: '',
            openQuestionSearch: false,
            questionViewType: 'survey'
        }
    }

    updateState = (value, state) => {
        this.setState({
            [state]: value
        }, () => {
            // if search or filter changes, set page to 0
            // if question modal is changed, set question data to null and question view type to survey
            if (state === 'searchTerm' || state === 'languageFilter' || state === 'typeFilter') {
                this.updateState(0, "page");
            } else if (state === 'questionModal') {
                this.updateState(null, "questionData");
                this.updateState('survey', 'questionViewType');
            }
        })
    }

    // when question is clicked from table, set its data to state
    onRowClick = (data) => {
        let deepCloneData = _.cloneDeep(data);
        this.setState({
            questionModal: true,
            questionData: deepCloneData
        });
    }

    // handles on change events for question data
    handleQuestionChange = (value, path, groupIdx = null) => {
        let dataCopy = { ...this.state.questionData };
        _.set(dataCopy, path, value);
        // if question's type is changed, ensure it is given valid Typeform properties
        if (path.includes('type') && value === 'opinion_scale') {
            let newProperties = {
                start_at_one: true,
                steps: 5,
                labels: { left: '', center: '', right: '' }
            };
            if (groupIdx || groupIdx === 0) {
                dataCopy["properties"]["fields"][groupIdx]["properties"] = newProperties;
            } else {
                dataCopy["properties"] = newProperties;
            }
        } else if (path.includes('type') && value === 'multiple_choice') {
            let newProperties = {
                choices: [],
                allow_multiple_selection: false,
                allow_other_choice: false
            };
            if (groupIdx || groupIdx === 0) {
                dataCopy["properties"]["fields"][groupIdx]["properties"] = newProperties;
            } else {
                dataCopy["properties"] = newProperties;
            }
        } else if (path === 'type' && value === 'group') {
            let newProperties = {
                fields: [],
                button_text: "Continue",
                show_button: true
            };
            if (groupIdx || groupIdx === 0) {
                dataCopy["properties"]["fields"][groupIdx]["properties"] = newProperties;
            } else {
                dataCopy["properties"] = newProperties;
            }
        } else if (path.includes('type') && value === 'statement') {
            if (groupIdx || groupIdx === 0) {
                dataCopy["properties"]["fields"][groupIdx]["properties"] = {};
                if (dataCopy["properties"]["fields"][groupIdx].validations) delete dataCopy["properties"]["fields"][groupIdx].validations;
            } else {
                dataCopy["properties"] = {};
                if (dataCopy.validations) delete dataCopy.validations;
            }
        } else if (path.includes('type')) {
            if (groupIdx || groupIdx === 0) {
                dataCopy["properties"]["fields"][groupIdx]["properties"] = {};
            } else {
                dataCopy["properties"] = {};
            }
        }
        this.setState({
            questionData: dataCopy
        });
    }

    // onChange handler for StringMap updates
    handleStringMapChange = (value, idx, type) => {
        let dataCopy = { ...this.state.questionData };
        dataCopy['StringMap'][idx][type] = value;
        this.setState({
            questionData: dataCopy
        });
    }

    // auto add survey options and retool options to stringMap
    autoMap = (surveyOptions, retoolOptions) => {
        let dataCopy = { ...this.state.questionData };
        if(!dataCopy['StringMap']){
            dataCopy['StringMap'] = [];
        }
        surveyOptions.forEach((choice, idx) => {
            if(!dataCopy['StringMap'][idx]){
                dataCopy['StringMap'][idx] = { survey: '', retool: '' }
            }
            dataCopy['StringMap'][idx].survey = choice;
        });
        retoolOptions.forEach((choice, idx) => {
            if(!dataCopy['StringMap'][idx]){
                dataCopy['StringMap'][idx] = { survey: '', retool: '' }
            }
            dataCopy['StringMap'][idx].retool = choice;
        });
        this.setState({
            questionData: dataCopy
        });
    }

    // removes StringMap item at given index
    deleteStringMap = (idx) => {
        let dataCopy = { ...this.state.questionData };
        dataCopy['StringMap'].splice(idx, 1);
        this.setState({
            questionData: dataCopy
        });
    }

    // appends new item to StringMap array
    addStringMap = () => {
        let dataCopy = { ...this.state.questionData };
        const newStringMap = {
            'retool': '',
            'survey': ''
        };
        if(dataCopy['StringMap']){
            dataCopy['StringMap'].push(newStringMap);
        }else{
            dataCopy['StringMap'] = [newStringMap];
        }
        this.setState({
            questionData: dataCopy
        });
    }

    // appends empty new child question to 'group' question
    handleGroupAddQuestion = () => {
        let dataCopy = { ...this.state.questionData };
        dataCopy["properties"]["fields"].push({
            title: '',
            ref: '',
            type: 'yes_no',
            properties: {}
        });
        this.setState({
            questionData: dataCopy
        });
    }

    // removes child question from 'group' question
    deleteGroupQuestion = (groupIdx) => {
        let dataCopy = { ...this.state.questionData };
        dataCopy["properties"]["fields"].splice(groupIdx, 1);
        this.setState({
            questionData: dataCopy
        });
    }

    // add choice to a child question in a 'group' multiple choice question
    handleGroupAddChoice = (groupIdx) => {
        let dataCopy = { ...this.state.questionData };
        dataCopy["properties"]["fields"][groupIdx]["properties"]["choices"].push({
            label: ''
        });
        this.setState({
            questionData: dataCopy
        });
    }

    // add choice to multiple choice question
    handleAddChoice = () => {
        let dataCopy = { ...this.state.questionData };
        if (dataCopy["properties"]["choices"]) {
            dataCopy["properties"]["choices"].push({
                label: ''
            });
        } else {
            dataCopy["properties"]["choices"] = [{ label: '' }];
        }
        this.setState({
            questionData: dataCopy
        });
    }

    // removes choice from multiple choice question
    handleDeleteChoice = (choiceIdx, groupIdx = null) => {
        let dataCopy = { ...this.state.questionData };
        if (groupIdx || groupIdx === 0) {
            dataCopy["properties"]["fields"][groupIdx]["properties"]["choices"].splice(choiceIdx, 1);
        } else {
            dataCopy["properties"]["choices"].splice(choiceIdx, 1);
        }
        this.setState({
            questionData: dataCopy
        });
    }

    // changes position of multiple choice option from fromIndex to toIndex
    handleMoveChoices = (fromIndex, toIndex, groupIdx = null) => {
        const { questionData } = this.state;
        let dataCopy = { ...questionData };
        const isGroupItem = (groupIdx || groupIdx === 0);
        let choicesCopy = isGroupItem ? [...questionData["properties"]["fields"][groupIdx]["properties"]["choices"]] : [...questionData["properties"]["choices"]];
        const item = choicesCopy.splice(fromIndex, 1)[0];
        choicesCopy.splice(toIndex, 0, item);
        if (isGroupItem) {
            dataCopy["properties"]["fields"][groupIdx]["properties"]["choices"] = choicesCopy;
        } else {
            dataCopy["properties"]["choices"] = choicesCopy;
        }
        this.setState({
            questionData: dataCopy
        });
    }

    // toggles alert dialogue
    toggleAlert = () => {
        this.setState({
            openAlert: !this.state.openAlert
        });
    }

    toggleUpdateQuestionAlert = () => {
        this.setState({
            alertTitle: "Update this question?",
            alertText: "This action can not be undone. Are you sure you want to update this question with the current fields?",
            alertType: "update"
        }, () => {
            this.toggleAlert();
        })
    }

    toggleNewQuestionAlert = () => {
        this.setState({
            alertTitle: "This question exists",
            alertText: "A question already exists with the same reference and language. If you want to update this question, search for it and click on the row containing the question."
        }, () => {
            this.toggleAlert();
        })
    }

    // if closed, opens add new question dialog and sets default data to state
    // if open, close dialog and set data to null
    toggleNewQuestion = () => {
        if (this.state.openNewQuestion === false) {
            let newQuestion = {
                title: '',
                ref: '',
                type: 'yes_no',
                properties: {},
                language: 'en',
                dateAdded: new Date(),
                display: true,
                StringMap: []
            }
            this.setState({
                openNewQuestion: true,
                questionData: newQuestion
            })
        } else {
            this.setState({
                openNewQuestion: false,
                questionData: null
            })
        }
    }

    toggleQuestionSearch = () => {
        this.setState({
            openQuestionSearch: !this.state.openQuestionSearch
        });
    }

    // updates question data in the database
    updateQuestion = () => {
        const { questionData } = this.state;
        db.collection('question_store').doc(questionData.id).set(questionData).then(() => {
            console.log(`Question ${questionData.ref} was successfully edited.`);
            this.setState({
                openSnackbar: true,
                snackbarMessage: `Question ${questionData.ref} was successfully edited.`,
                openAlert: false,
                questionModal: false,
                questionData: null,
                questionViewType: 'survey'
            });
        }).catch(err => {
            console.log("Error updating question: ", err);
        })
    }

    // adds new question to database
    addQuestion = () => {
        const { questionData } = this.state;
        console.log(questionData);
        if (questionData.title && questionData.ref) {
            // check if question with given ref and language already exists in the database
            let questionExists = this.context.find(q => (
                (q.ref === questionData.ref) && (q.language === questionData.language)
            ));
            if (questionExists) {
                this.setState({
                    openSnackbar: true,
                    snackbarMessage: "Question with this ref and language already exists"
                });
            } else {
                console.log("Adding document...");
                var newQuestionRef = db.collection('question_store').doc();
                newQuestionRef.set({ ...questionData, id: newQuestionRef.id }).then(() => {
                    this.setState({
                        openSnackbar: true,
                        snackbarMessage: `Question ${questionData.ref} was successfully added.`,
                        openNewQuestion: false,
                        questionData: null,
                        questionViewType: 'survey'
                    });
                }).catch(err => {
                    console.log("Error adding doc: ", err);
                })
            }
        } else {
            this.setState({
                openSnackbar: true,
                snackbarMessage: "Please fill out title and/or ref fields."
            });
        }
    }

    toggleSnackbar = () => {
        this.setState({
            openSnackbar: !this.state.openSnackbar
        })
    }

    handleGroupAddExistingQuestion = (idx) => {
        this.setState({
            openQuestionSearch: true,
        })
    }

    // adds question data to group question
    onQuestionSearchClick = (data) => {
        let dataCopy = { ...this.state.questionData };
        let newQuestion = {
            title: data.title,
            ref: data.ref,
            type: data.type,
            properties: data.properties,
        }
        if (data.type !== 'statement') {
            newQuestion.validations = { required: true };
        } else {
            newQuestion.properties.button_text = "Continue";
        }
        if (data.type !== 'group') {
            dataCopy["properties"]["fields"].push(newQuestion);
            this.setState({
                fields: dataCopy,
                openQuestionSearch: false
            });
        } else {
            this.setState({
                openSnackbar: true,
                snackbarMessage: "Can't add group question to group"
            })
        }
    }

    // add question to archived question array and remove from question_store collection
    archiveQuestion = () => {
        const { questionData } = this.state;
        console.log("Archiving question: ", questionData);
        let archivedRef = db.collection("archived").doc('archived_questions');
        let newArchived = {
            questionData: questionData,
            dateArchived: new Date()
        }
        archivedRef.update({
            questions: firebase.firestore.FieldValue.arrayUnion(newArchived)
        }).then(() => {
            db.collection("question_store").doc(questionData.id).delete().then(() => {
                console.log("Successfully archived question");
                this.setState({
                    openSnackbar: true,
                    snackbarMessage: `Question was successfully archived.`,
                    openAlert: false,
                    questionModal: false,
                    questionData: null,
                    questionViewType: 'survey'
                });
            }).catch(function (error) {
                console.error("Error removing question from question_store: ", error);
            });
        }).catch(err => {
            console.log("Error archiving question: ", err);
            this.setState({
                openSnackbar: true,
                snackbarMessage: `Error archiving question.`,
            });
        })
    }

    toggleArchiveQuestionAlert = () => {
        this.setState({
            alertTitle: "Archive this question?",
            alertText: "Are you sure you want to archive this question? This question can be restored by going to the archived questions tab.",
            alertType: "archive"
        }, () => {
            this.toggleAlert();
        })
    }

    handleAlertYes = () => {
        const { alertType } = this.state;
        if (alertType === 'update') {
            this.updateQuestion();
        } else if (alertType === 'archive') {
            this.archiveQuestion();
        } else {
            console.log("Not a valid alert type");
        }
    }

    toggleQuestionViewType = () => {
        const { questionViewType } = this.state;
        const newViewType = (questionViewType === 'survey') ? 'analysis' : 'survey';
        this.setState({
            questionViewType: newViewType
        });
    }

    render() {
        const { searchTerm, typeFilter, languageFilter, rowsPerPage, page, questionModal, questionData, questionViewType } = this.state;
        let filteredQuestions = this.context.filter(filterQuestions(searchTerm));
        if (typeFilter) {
            filteredQuestions = filteredQuestions.filter(question => question.type === this.state.typeFilter);
        }
        if (languageFilter) {
            filteredQuestions = filteredQuestions.filter(question => question.language === this.state.languageFilter);
        }
        return (
            <div style={{ textAlign: 'center', width: '100%', padding: 10, position: 'relative' }}>
                <h2> Survey Questions </h2>
                <Button onClick={this.toggleNewQuestion} style={{ position: 'absolute', right: 30, top: 20, width: 150 }} variant="outlined" color="primary"> NEW QUESTION </Button>
                <Button variant="outlined" color="secondary" onClick={() => this.props.history.push('/archivedquestions')} style={{ position: 'absolute', left: 20, top: 20 }}>Archived Questions</Button>
                <div style={{ display: 'flex' }}>
                    <TextField
                        id="search-input" variant="outlined"
                        value={searchTerm}
                        onChange={(e) => this.updateState(e.target.value, "searchTerm")}
                        InputProps={{ startAdornment: (<InputAdornment position="start"> <SearchIcon /> </InputAdornment>) }}
                        style={styles['search']}
                        autoComplete="off"
                    />
                    <select style={styles['select']} value={typeFilter} onChange={(e) => this.updateState(e.target.value, 'typeFilter')}>
                        <option value="">Type</option>
                        {types.map(type => (
                            <option key={type.value} value={type.value}> {type.label} </option>
                        ))}
                    </select>
                    <select style={styles['select']} value={languageFilter} onChange={(e) => this.updateState(e.target.value, 'languageFilter')}>
                        <option value="">Language</option>
                        {languages.map(language => (
                            <option key={language.value} value={language.value}> {language.label} </option>
                        ))}
                    </select>
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ width: '95%' }}>
                        <TableComponent
                            data={filteredQuestions}
                            headers={["Ref", "Text", "Type", "Language", "Date added"]}
                            fields={["ref", "title", "type", "language", "dateAdded"]}
                            updateState={this.updateState}
                            onRowClick={this.onRowClick}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            count={filteredQuestions.length}
                        />
                    </div>
                    <Dialog
                        open={questionModal}
                        onClose={() => this.updateState(!questionModal, "questionModal")}
                        fullWidth={true}
                        maxWidth={"md"}
                        aria-labelledby="question-dialog-title"
                    >
                        <DialogTitle id="question-dialog-title">
                            Question View
                            <Button variant="outlined" color="secondary" onClick={this.toggleArchiveQuestionAlert} style={{ position: 'absolute', right: 10 }}>Archive</Button>
                        </DialogTitle>
                        <DialogContent>
                            <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', width: '100%' }}>
                                {questionData &&
                                    <div style={{ width: '99%' }}>
                                        {questionViewType === 'survey' ?
                                            <Fragment>
                                                <select style={{ ...styles['select'], height: 40 }} value={questionData.language} onChange={(e) => this.handleQuestionChange(e.target.value, 'language')}>
                                                    {languages.map(language => (
                                                        <option key={language.value} value={language.value}> {language.label} </option>
                                                    ))}
                                                </select>
                                                <CreateQuestion
                                                    field={questionData}
                                                    handleQuestionChange={this.handleQuestionChange}
                                                    handleAddChoice={this.handleAddChoice}
                                                    handleDeleteChoice={this.handleDeleteChoice}
                                                    handleGroupAddChoice={this.handleGroupAddChoice}
                                                    handleGroupAddQuestion={this.handleGroupAddQuestion}
                                                    handleGroupAddExistingQuestion={this.handleGroupAddExistingQuestion}
                                                    deleteGroupQuestion={this.deleteGroupQuestion}
                                                    handleDragEnd={this.handleMoveChoices}
                                                    questionView={true}
                                                    disableRef={true}
                                                />
                                            </Fragment>
                                            :
                                            <Fragment>
                                                <AnalysisFields
                                                    data={questionData}
                                                    handleQuestionChange={this.handleQuestionChange}
                                                    handleStringMapChange={this.handleStringMapChange}
                                                    deleteStringMap={this.deleteStringMap}
                                                    addStringMap={this.addStringMap}
                                                    existingQuestions={this.context}
                                                    autoMap={this.autoMap}
                                                />
                                            </Fragment>
                                        }
                                    </div>
                                }
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="outlined" color="primary" style={{ left: 5, position: 'absolute' }} onClick={this.toggleQuestionViewType}>
                                {questionViewType === 'survey' ? 'Analysis Fields' : 'Survey Fields'}
                            </Button>
                            <Button variant="outlined" onClick={() => this.updateState(!this.state.questionModal, "questionModal")}>Close</Button>
                            <Button variant="outlined" onClick={this.toggleUpdateQuestionAlert}>Save Edits</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={this.state.openNewQuestion}
                        onClose={this.toggleNewQuestion}
                        fullWidth={true}
                        maxWidth={"md"}
                        aria-labelledby="new-question-title"
                    >
                        <DialogTitle id="question-dialog-title">New Question</DialogTitle>
                        <DialogContent>
                            <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', width: '100%' }}>
                                {this.state.questionData &&
                                    <div style={{ width: '99%' }}>
                                        <select style={{ ...styles['select'], height: 40 }} value={this.state.questionData.language} onChange={(e) => this.handleQuestionChange(e.target.value, 'language')}>
                                            {languages.map(language => (
                                                <option key={language.value} value={language.value}> {language.label} </option>
                                            ))}
                                        </select>
                                        <CreateQuestion
                                            field={this.state.questionData}
                                            handleQuestionChange={this.handleQuestionChange}
                                            handleAddChoice={this.handleAddChoice}
                                            handleDeleteChoice={this.handleDeleteChoice}
                                            handleGroupAddChoice={this.handleGroupAddChoice}
                                            handleGroupAddExistingQuestion={this.handleGroupAddExistingQuestion}
                                            handleGroupAddQuestion={this.handleGroupAddQuestion}
                                            deleteGroupQuestion={this.deleteGroupQuestion}
                                            questionView={true}
                                        />
                                    </div>
                                }
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="outlined" onClick={this.toggleNewQuestion}>Close</Button>
                            <Button variant="outlined" onClick={this.addQuestion}>Add Question</Button>
                        </DialogActions>
                    </Dialog>
                </div>
                {this.context.length > 0 &&
                    <SearchDialog
                        data={this.context}
                        open={this.state.openQuestionSearch}
                        toggleOpen={this.toggleQuestionSearch}
                        onRowClick={this.onQuestionSearchClick}
                    />
                }
                <AlertDialog
                    open={this.state.openAlert}
                    title={this.state.alertTitle}
                    text={this.state.alertText}
                    noClick={this.toggleAlert}
                    yesClick={this.state.openNewQuestion ? null : this.handleAlertYes}
                />
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={this.state.openSnackbar}
                    autoHideDuration={5000}
                    onClose={this.toggleSnackbar}
                    message={this.state.snackbarMessage}
                    action={
                        <IconButton size="small" aria-label="close" color="inherit" onClick={this.toggleSnackbar}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    }
                    style={{ fontSize: 14 }}
                />
            </div>
        )
    }
};

AllQuestions.contextType = QuestionContext;

export default AllQuestions;
